import { getApiHost } from "./api-host";

// Serves the legacy readers of Sparkle.apiHost.
Object.defineProperty((window.Sparkle ??= {}), "apiHost", {
  configurable: true,
  enumerable: true,
  get: () => getApiHost().apiHost,
});
